import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../core/hooks/storeHooks';
import { validateIfSheetIsInGroup } from '../../sheet/utils/groups/metaData';
import { closeWindow, switchActiveSheet } from '../redux/windowsSlice';
import { SheetWindowApp, WindowMetaData } from '../types';
import { isSheetAppWindow } from '../utils/validator';
import { loadSheetGroup } from '../../sheet/redux/sagas/views/viewsActions';

export default function useAppWindowValidation(
  windowId: string,
  metaData?: WindowMetaData
) {
  const loading = false; //TODO: Replace it with master loading - solution level loading
  const dispatch = useAppDispatch();
  const sheetGroups = useAppSelector(
    (state) => state.sheetsManager.sheetGroups
  );
  const entityIdToNameMap = useAppSelector(
    (state) => state.sheetsManager.entityIdToNameMap
  );

  useEffect(() => {
    const isSheetApp = isSheetAppWindow(metaData);

    if (isSheetApp && !loading) {
      const sheetAppMetaData = metaData as SheetWindowApp;
      const groupId = sheetAppMetaData.groupId;
      const sheetId = sheetAppMetaData.sheetId;
      const group = sheetGroups[groupId];

      // console.log('group', group, groupsIdToName, groupId);

      if (!group) {
        if (entityIdToNameMap.groupsIdToName[groupId]) {
          dispatch(loadSheetGroup(groupId));
        } else {
          dispatch(closeWindow(windowId));
        }
      } else {
        if (!entityIdToNameMap.sheetsIdToName[sheetId]) {
          dispatch(
            switchActiveSheet({ id: windowId, sheetId: group.sheets[0] })
          );
        }
      }
    }
  }, [metaData, entityIdToNameMap, sheetGroups, loading]);

  //   Validate if group is in memory or sheet exists inside a group
  // useEffect(() => {
  //   const isSheetApp = isSheetAppWindow(metaData);

  //   if (isSheetApp && !loading) {
  //     const sheetAppMetaData = metaData as SheetWindowApp;
  //     const group = sheetGroups[sheetAppMetaData.groupId];

  //     console.log('group', group);

  //     if (!group) {
  //       dispatch(loadSheetGroup(sheetAppMetaData.groupId));
  //     }

  //     // if (
  //     //   !group ||
  //     //   !validateIfSheetIsInGroup(group, sheetAppMetaData.sheetId)
  //     // ) {
  //     //   if (!group || !group.sheets.length) {
  //     //     console.log('Force close...');
  //     //     dispatch(closeWindow(windowId));
  //     //   } else {
  //     //     console.log('Switching window...');
  //     //     const firstSheetId = group.sheets[0] ?? '';
  //     //     dispatch(switchActiveSheet({ id: windowId, sheetId: firstSheetId }));
  //     //   }
  //     // }
  //   }
  // }, [metaData, sheetGroups, loading]);
}
